<template>
    <v-flex fill-height>
        <sidemainmenu/>
        <br />
        <v-progress-linear slot="extension" :indeterminate="true"  v-if="loading" class="ma-0"></v-progress-linear>
        <v-layout wrap justify-space-between>
            <v-card  class="mx-auto" min-width="100%">
            <v-card-title>
                <v-form>
                    <v-flex>
                        <v-layout>
                            <v-flex>
                                <v-btn block color="warning" v-on:click="seen = !seen">Add New<v-icon right dark>add</v-icon></v-btn>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-form>
            </v-card-title>
            <v-card-text>
                <v-card v-if="seen">
                    <v-card-title>
                        Customer Master
                        <v-spacer></v-spacer>
                        <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                    </v-card-title>
                    <v-data-table :headers="headers" :items="customer" :search="search" class="elevation-1" :rows-per-page-items = "[15, 50, 100, 500]">
                        <template v-slot:items="props">
                            <td>{{ props.item.id }}</td>
                            <td class="text-xs-right">{{ props.item.name }}</td>
                            <td class="text-xs-right">{{ props.item.code }}</td>
                            <td class="text-xs-right">{{ props.item.gst_no }}</td>
                            <td class="text-xs-right">{{ props.item.pan_no }}</td>
                            <td class="text-xs-right">{{ props.item.website }}</td>
                            <td class="text-xs-right">{{ props.item.email }}</td>
                            <td class="text-xs-right">{{ props.item.street_address1 }}</td>
                            <td class="text-xs-right">{{ props.item.street_address2 }}</td>
                            <td class="text-xs-right">{{ props.item.city }}</td>
                            <td class="text-xs-right">{{ props.item.state }}</td>
                            <td class="text-xs-right">{{ props.item.country }}</td>
                            <td class="text-xs-right">{{ props.item.zip_code }}</td>
                            <td class="text-xs-right">{{ props.item.phone_no }}</td>
                            <td class="text-xs-right">{{ props.item.landline_no }}</td>
                            <td class="text-xs-right">{{ props.item.fax_no }}</td>
                        </template>
                        <template v-slot:no-results>
                            <v-alert :value="true" color="error" icon="warning">
                                Your search for "{{ search }}" found no results.
                            </v-alert>
                        </template>
                    </v-data-table>
                </v-card>
                <v-card  v-else>
                    <v-form v-model="valid" ref="form">
                    <v-card-title>Add New Customer
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-card-text class="mx-auto">
                        <v-container grid-list-xl>
                            <v-layout wrap justify-space-between>
                                <v-flex xs12 md4>
                                    <v-text-field v-model="txtcustomername" label="Customer Name" :rules="[(v) => !!v || 'Customer Name is required']" required ></v-text-field>
                                </v-flex>
                                <v-flex xs12 md4>
                                    <v-text-field v-model="txtcustomercode" label="Customer Code" :rules="[(v) => !!v || 'Customer Code is required']" required ></v-text-field>
                                </v-flex>
                                <v-flex xs12 md4>
                                    <v-text-field v-model="txtgst" :counter="16" label="Customer GST" :rules="[(v) => !!v || 'GST is required']" required ></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout wrap justify-space-between>
                                <v-flex xs12 md4>
                                    <v-text-field v-model="txtpan" label="PAN" required :rules="[(v) => !!v || 'PAN is required']" ></v-text-field>
                                </v-flex>
                                <v-flex xs12 md4>
                                    <v-text-field v-model="txtwebsite" label="Web Site" required ></v-text-field>
                                </v-flex>
                                <v-flex xs12 md4>
                                    <v-text-field v-model="txtemail" label="Email" required ></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout wrap justify-space-between>
                                <v-flex xs12 md4>
                                    <v-text-field v-model="txtaddress1" label="Street" required ></v-text-field>
                                </v-flex>
                                <v-flex xs12 md4>
                                    <v-text-field v-model="txtaddress2" label="Area / Landmark / village / Taluk" required ></v-text-field>
                                </v-flex>
                                <v-flex xs12 md4>
                                    <v-text-field v-model="txtcity" label="City" required ></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout wrap justify-space-between>
                                <v-flex xs12 md4>
                                    <v-select v-model="cbostate" :items="state_list" item-value="id" item-text="text" :rules="[(v) => !!v || 'State is required']"></v-select>
                                </v-flex>
                                <v-flex xs12 md4>
                                    <v-text-field v-model="txtcountry" label="Country"></v-text-field>
                                </v-flex>
                                <v-flex xs12 md4>
                                    <v-text-field v-model="txtpincode" label="PIN Code"></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout wrap justify-space-between>
                                <v-flex xs12 md4>
                                    <v-text-field v-model="txtphone" label="Phone"></v-text-field>
                                </v-flex>
                                <v-flex xs12 md4>
                                    <v-text-field v-model="txtlandline" label="Landline" ></v-text-field>
                                </v-flex>
                                <v-flex xs12 md4>
                                    <v-text-field v-model="txtfax" label="Fax"></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout wrap justify-space-between>
                                <v-flex xs12 md4>
                                </v-flex>
                                <v-flex xs12 md4>
                                </v-flex>
                                <v-flex xs12 md4>
                                    <v-btn color="success" v-bind:disabled="btnDisable" v-on:click="submitData()">Save</v-btn>
                                    <v-btn color="error" v-on:click="clearData()">Clear</v-btn>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                </v-form>
                </v-card>
            </v-card-text>
            </v-card>
        </v-layout>
    <br />
    <bottomfootermenus/>
    </v-flex>
</template>


<script>
import sidemainmenu from '@/components/header.vue';
import bottomfootermenus from '@/components/footer.vue';
import axios from 'axios';
    const toLower = text => {
            return text.toString().toLowerCase()
        }

        const searchByName = (items, term) => {
            if (term) {
              return items.filter(item => toLower(item.name).includes(toLower(term)))
            }

            return items
        }
  export default {
    name: 'customer',
    data() {
        return {
            error: false,
            updatestatusnoti: false,
            alerterror: false,
            seen: true,
            search: null,
            customer: [],
            activeVal: "Open",
            btnDisable: false,
            loading: false,
            txtcustomername: null,
            txtcustomercode: null,
            txtgst: null,
            txtpan: null,
            txtwebsite: null,
            txtemail: null,
            txtaddress1: null,
            txtaddress2: null,
            txtcity: null,
            cbostate: null,
            txtcountry: null,
            txtpincode: null,
            txtphone: null,
            txtlandline: null,
            txtfax: null,
            crossDomain : true,
            xhrFields: {
                withCredentials: true
            },
            search: '',
            headers: [
              { text: 'S.No', align: 'left', value: 'id' },
              { text: 'Customer Name', align: 'right', value: 'name' },
              { text: 'Code', align: 'right', value: 'code' },
              { text: 'GST', align: 'right', value: 'gst_no' },
              { text: 'PAN', align: 'right', value: 'pan_no' },
              { text: 'Website', align: 'right', value: 'website' },
              { text: 'Email', align: 'right', value: 'email' },
              { text: 'Street', align: 'right', value: 'street_address1' },
              { text: 'Taluk', align: 'right', value: 'street_address2' },
              { text: 'City', align: 'right', value: 'city' },
              { text: 'State', align: 'right', value: 'state' },
              { text: 'Country', align: 'right', value: 'country' },
              { text: 'PIN', align: 'right', value: 'zip_code' },
              { text: 'Phone', align: 'right', value: 'phone_no' },
              { text: 'Landline', align: 'right', value: 'landline_no' },
              { text: 'Fax', align: 'right', value: 'fax_no' }
            ]
        }
    },
    mounted:function(){
        this.getData(),
        this.getState()
    },
    components: {
        sidemainmenu,
        bottomfootermenus,
    },
    methods: {
        getData: function () {
            this.loading = true;
            this.API_URL = this.$hostname + "/masters/customer"
            axios.get(this.API_URL, { headers: {"Authorization" : 'jwt ' + localStorage.jwt} })
            .then((response) => {
                this.loading = false;
                this.customer = response.data;
            }, (error) => {
                this.loading = false;
                this.error = true;
            })
        },
        searchOnTable () {
            this.state = searchByName(this.state, this.search)
        },
        submitData: function() {
            if(!this.$refs.form.validate()) {
                return false
            }
            this.btnDisable = true;
            this.loading = true;
            const data = {'crossDomain': true,
                          'name': this.txtcustomername,
                          'code': this.txtcustomercode,
                          'gst_no': this.txtgst,
                          'pan_no': this.txtpan,
                          'website': this.txtwebsite,
                          'email': this.txtemail,
                          'street_address1': this.txtaddress1,
                          'street_address2': this.txtaddress2,
                          'city': this.txtcity,
                          'state': this.cbostate,
                          'country': this.txtcountry,
                          'zip_code': this.txtpincode,
                          'phone_no': this.txtphone,
                          'landline_no': this.txtlandline,
                          'fax_no': this.txtfax,
                          'created_by': localStorage.username}
            axios.post(this.$hostname + '/masters/customer', data,
                       { headers: {"Authorization" : 'jwt ' + localStorage.jwt} })
                 .then(response => {
                    this.btnDisable = false;
                    this.loading = false;
                    this.alertsuccess = true;
                    window.location.reload();
                 }, (error) => {
                    console.log(error.response);
                    this.btnDisable = false;
                    this.loading = false;
                    this.alerterror = true;
                })
        },
        getState: function () {
            this.API_URL = this.$hostname + "/combos/state"
            axios.get(this.API_URL, { headers: {"Authorization" : 'jwt ' + localStorage.jwt} })
            .then((response) => {
                this.state_list = response.data;
            }, (error) => {
                this.error = true;
            })
        },
        clearData: function() {
            this.txtcustomername = null;
            this.txtcustomercode = null;
            this.txtgst = null;
            this.txtpan = null;
            this.txtwebsite = null;
            this.txtemail = null;
            this.txtaddress1 = null;
            this.txtaddress2 = null;
            this.txtcity = null;
            this.cbostate = null;
            this.txtcountry = null;
            this.txtpincode = null;
            this.txtphone = null;
            this.txtlandline = null;
            this.txtfax = null;
        }
    }
  }
</script>
